<div
  class="card combo-chart-card"
  *ngIf="data"
  [style.height]="data?.cardHeight"
  [style.margin-bottom]="data?.marginBottom"
  [style.margin-top]="data?.marginTop"
>
  <div class="card-header combo-chart-header">
    <div class="card-title">
      <h4>{{ data.title || 'Grouped Bar and Multi-Line Trend Chart' }}</h4>
      <p *ngIf="data?.subtitle">{{ data.subtitle }}</p>
    </div>

    <div class="meta-info" *ngIf="metaInfo">
      <span *ngIf="hasMetaValue(metaInfo.totalRecords)">Records: {{ metaInfo.totalRecords }}</span>
      <span *ngIf="hasMetaValue(metaInfo.totalPages)">Pages: {{ metaInfo.totalPages }}</span>
      <span *ngIf="hasMetaValue(metaInfo.pageSize)">Page Size: {{ metaInfo.pageSize }}</span>
    </div>
  </div>

  <div class="card-body">
    <div
      [id]="data.widgetId"
      class="combo-chart-host"
      [style.height]="data?.chartHeight || data?.height || data?.chartConfig?.chartHeight || data?.chartConfig?.height || 'var(--dvm-chart-height-lg, 400px)'"
    ></div>
  </div>
</div>
